export const trackWhatsAppLead = (source, extra = {}) => {
  try {
    if (window.fbq) window.fbq('track', 'Lead', { content_name: source, content_category: 'WhatsApp Click', ...extra });
    if (window.dataLayer) window.dataLayer.push({ event: 'whatsapp_lead', landing: source, ...extra });
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/leads/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ source, language: extra.language || null, path: window.location.pathname }),
      keepalive: true
    }).catch(() => {});
  } catch (e) { /* tracking must never block the CTA */ }
};
